import { PaginationTemplate } from './PaginationTemplate';

export default PaginationTemplate;
